module.exports = __webpack_public_path__ + "static/media/check-circle-solid.78c96121.svg";